'use strict'
import OrderTableByState from './OrderTableByState'

export default function OrderTablePrenotatoRitiro() {
  return <OrderTableByState states={[50]} title="Ordini Prenotato Ritiro" />
}
